import React from "react"
import classNames from "classnames"

export default function Spinner({ className = "", dark = false }) {
  const spinnerClassName = classNames(
    "xmlPreloader",
    { "xmlPreloader--green": dark },
    className,
  )
  return (
    <div className={spinnerClassName} style={{ display: "block" }}>
      <div className="xmlPreloader__content">
        <span />
        <span />
        <span />
        <span />
      </div>
    </div>
  )
}
